import React from "react";
import { Row, Col, Container } from "react-bootstrap";

import imgC1 from "../../assets/image/inner/about-content-2.png";
import imgC2 from "../../assets/image/inner/about-content-2.png";
import imgC3 from "../../assets/image/inner/about-content-3.png";
import imgC4 from "../../assets/image/inner/about-content-4.png";

const Founders = ({data}) => (
  <>
    {/* <!-- Content section 1 --> */}
    <div className="content-section pt-14 pt-lg-27 pb-13 pb-lg-27 bg-default-2">
      <Container>
        <Row className="align-items-center justify-content-center">
          <Col sm="8" lg="5" xl="6" className="mb-9 mb-lg-0">
            <div className="content-grid-image-group d-flex  mx-sm-n3">
              <div className="single-image d-flex flex-column px-3 px-sm-6">
                <img
                  src={data.founders_image_1.url}
                  alt={data.founders_image_1.alt}
                  data-aos="zoom-in"
                  data-aos-duration="500"
                  className="w-100 pb-6 pb-sm-9 rounded-10"
                />

                <img
                  src={data.image_founders_2.url}
                  alt={data.image_founders_2.alt}
                  data-aos="zoom-in"
                  data-aos-duration="500"
                  data-aos-delay="800"
                  className="w-100 pb-6 pb-sm-9 rounded-10"
                />
              </div>
              <div className="single-image d-flex flex-column pt-11 px-3 px-sm-6">
                <img
                  src={data.image_founders_3.url}
                  alt={data.image_founders_3.alt}
                  data-aos="zoom-in"
                  data-aos-duration="500"
                  data-aos-delay="400"
                  className="w-100 pb-6 pb-sm-9 rounded-10"
                />

                <img
                  src={data.image_founders_4.url}
                  alt={data.image_founders_4.alt}
                  data-aos="zoom-in"
                  data-aos-duration="500"
                  data-aos-delay="1200"
                  className="w-100 rounded-10"
                />
              </div>
            </div>
          </Col>
          <Col
            sm="8"
            lg="6"
            xl="5"
            className="offset-lg-1 offset-lg-1 offset-xl-0"
          >
            <div className="content-text">
              <h2 className="gr-text-3 mb-7 mb-lg-11">About The Founders</h2>
              <h3>{data.founder_title_one.text}</h3>
              <p className="gr-text-8 mb-7 mb-lg-10">
                {data.founder_description_one.text}{" "}
              </p>
              <h3>{data.founder_title_two.text}</h3>
              <p className="gr-text-8 mb-0">
                {data.founder_description_two.text}{" "}
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  </>
);

export default Founders;
